import React, { createContext, useCallback, useContext, useMemo, useState } from 'react';

type ApplicationState = {
  storedValues: Record<string, any>;
  setStoredValue: (params: { key: string; value: any }) => void;
};

const defaultState: ApplicationState = {
  storedValues: {},
  setStoredValue: () => {},
};

const ApplicationStateContext = createContext<ApplicationState>(defaultState);

type Props = {
  children: React.ReactNode;
};

const ApplicationStateProvider = ({ children }: Props) => {
  const [storedValues, setStoredValues] = useState<ApplicationState['storedValues']>(
    defaultState.storedValues
  );

  /*
  React.useEffect(() => {
    console.log('AppState storedValues:', storedValues);
  }, [storedValues]);
  */

  const setStoredValue: ApplicationState['setStoredValue'] = useCallback(({ key, value }) => {
    setStoredValues((prevValues) => ({
      ...prevValues,
      [key]: value,
    }));
  }, []);

  const value = useMemo(() => ({ storedValues, setStoredValue }), [storedValues, setStoredValue]);

  return (
    <ApplicationStateContext.Provider value={value}>{children}</ApplicationStateContext.Provider>
  );
};

export const useAppState = () => {
  const context = useContext(ApplicationStateContext);
  if (context === undefined) {
    throw new Error('useAppState must be used within ApplicationStateProvider');
  }

  return context;
};

ApplicationStateProvider.Context = ApplicationStateContext;

export default ApplicationStateProvider;
